import {
  Text,
  IconXMark,
  Button,
  SequenceMenu,
  GreyGrey30,
  GreyGrey60,
  GreyGrey80,
  Primary13SemiBold,
  Center,
  Box,
  Flex
} from '@sequencehq/core-components'
import {
  AttachmentReducerAction,
  AttachmentReducerState
} from './attachmentReducer'
import { FC } from 'react'
import { AttachmentPdfPreview } from './AttachmentPdfPreview'
import { match } from 'ts-pattern'
import { AttachmentBinaryPreview } from './AttachmentBinaryPreview'

export const AttachmentPreview: FC<{
  state: AttachmentReducerState
  dispatch: React.Dispatch<AttachmentReducerAction>
  disableControls?: boolean
}> = ({ state, dispatch, disableControls }) => {
  const { attachmentToPreview: attachment } = state

  if (!attachment) {
    return null
  }

  return (
    <Flex flexDirection="column" height="100%">
      <Header
        onClickClose={() => {
          dispatch({ type: 'PREVIEW_ATTACHMENT', attachment: null })
        }}
        onClickDelete={() => {
          dispatch({
            type: 'DELETE_ATTACHMENT',
            attachment
          })
        }}
        disableControls={disableControls}
      />
      <Box flexGrow={1} position="relative">
        {match(attachment.type)
          .with('BINARY', 'IMAGE', () => (
            <AttachmentBinaryPreview
              url={attachment.url}
              fileName={attachment.fileName}
            />
          ))
          .with('DOCUMENT', () => (
            <AttachmentPdfPreview
              url={attachment.url}
              fileName={attachment.fileName}
              data-testid={`attachments.inspector.pdf-viewer.${attachment.id}`}
            />
          ))
          .exhaustive()}
      </Box>
    </Flex>
  )
}

const Header: FC<{
  onClickClose: VoidFunction
  onClickDelete: VoidFunction
  disableControls?: boolean
}> = ({ onClickClose, onClickDelete, disableControls }) => {
  return (
    <Flex
      flexDirection="column"
      px="8px"
      py="12px"
      borderBottom={`1px solid ${GreyGrey30}`}
    >
      <Flex alignItems="center" justifyContent="space-between" px="8px">
        <Text {...Primary13SemiBold} color={GreyGrey80}>
          Preview
        </Text>

        <Flex gap="8px">
          <SequenceMenu
            variant="ghost"
            alignment="bottom-right"
            buttonSize="small"
            items={[
              <SequenceMenu.Item
                key="delete"
                uuid="delete"
                label="Delete attachment"
                isDisabled={!!disableControls}
                onClick={e => {
                  e.stopPropagation()
                  onClickDelete()
                }}
                style={{ color: 'red' }}
              />
            ]}
          />
          <Button
            variant="ghost"
            size="24px"
            onClick={onClickClose}
            aria-label="Close preview"
          >
            <Center>
              <IconXMark color={GreyGrey60} />
            </Center>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}
